// extracted by css-extract-rspack-plugin
export default {"cls1":"Tabs-cls1_eYZ","cls2":"Tabs-cls2_93j Tabs-cls1_eYZ"};